import http from "@/axios";
import {
    CommentBody,
    CommentsDto,
    ForumDto,
    ForumFilter,
    ForumRequestBody,
    ForumTab,
    Tag,
    TopicBody
} from "@/store/forum/types";
import {ForumUtils} from "@/utils/forum-utils";

export default class ForumStore {

    public static chosenTag: Tag | undefined = undefined;

    public static getDefault(clanId: number | undefined, pageNum: number): Promise<ForumDto> {
        if (!clanId) {
            clanId = ForumUtils.COMMON_FORUM_ID;
        }
        return http.post('/api/forum/topic/list/page/' + String(pageNum) + '/' + String(clanId))
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new ForumDto(), rObj);
            });
    }

    public static getForum(clanId: number | undefined, forumTab: ForumTab, tags: Tag[], filter: ForumFilter, page: number): Promise<ForumDto> {
        if (!clanId) {
            clanId = ForumUtils.COMMON_FORUM_ID;
        }
        let frb: ForumRequestBody = new ForumRequestBody();
        frb.tags = tags;
        frb.forumTab = forumTab;
        frb.forumFilter = filter;
        frb.page = page;
        return http.post('/api/forum/topic/list' + '/' + String(clanId), frb)
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new ForumDto(), rObj);
            });
    }

    public static getComments(topicId: number, page: number): Promise<CommentsDto> {
        return http.post('/api/forum/comment/list/' + String(topicId)  + '/page/' + String(page))
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new CommentsDto(), rObj);
            });
    }

    public static createTopic(clanId: number | undefined, tags: Tag[], title: string, text: string, guest: boolean): Promise<ForumDto> {
        if (!clanId) {
            clanId = ForumUtils.COMMON_FORUM_ID;
        }
        let tb: TopicBody = new TopicBody();
        tb.tags = tags;
        tb.title = title;
        tb.text = text;
        tb.guest = guest;
        return http.post('/api/forum/topic/create/' + String(clanId), tb)
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new ForumDto(), rObj);
            });
    }

    public static editTopic(topicId: number, tags: Tag[], title: string, text: string, guest: boolean): Promise<ForumDto> {
        let tb: TopicBody = new TopicBody();
        tb.tags = tags;
        tb.title = title;
        tb.text = text;
        tb.guest = guest;
        return http.post('/api/forum/topic/' + String(topicId) + '/edit', tb)
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new ForumDto(), rObj);
            });
    }

    public static editComment(commentId: number, text: string): Promise<CommentsDto> {
        let cb: CommentBody = new CommentBody();
        cb.text = text;
        return http.post('/api/forum/comment/' + String(commentId) + '/edit', cb)
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new CommentsDto(), rObj);
            });
    }

    public static removeTopic(topicId: number): Promise<ForumDto> {
        return http.post('/api/forum/topic/' + String(topicId) + '/remove')
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new ForumDto(), rObj);
            });
    }

    public static removeComment(commentId: number): Promise<CommentsDto> {
        return http.post('/api/forum/comment/' + String(commentId) + '/remove')
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new CommentsDto(), rObj);
            });
    }

    static pinTopic(topicId: number, pinned:boolean): Promise<ForumDto> {
        var params = new URLSearchParams();
        params.append('pinned', String(pinned));

        return http.post('/api/forum/topic/' + String(topicId) + '/pin', params)
            .then(r => r.data)
            .then(rObj => {

                return Object.assign(new ForumDto(), rObj);
            });
    }

    public static createComment(topicId: number, text: string): Promise<CommentsDto> {
        let cb: CommentBody = new CommentBody();
        cb.topicId = topicId;
        cb.text = text;
        return http.post('/api/forum/comment/create', cb)
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new CommentsDto(), rObj);
            });
    }

    public static actualizeChosenTag(fd: ForumDto): void {
        fd.headTags.forEach(t => {
            if (fd.selectedTags.length == 1 && fd.selectedTags.includes(t)) {
                ForumStore.chosenTag = t;
            }
        })
    }

    public static voteTopic(topicId: number, value: number): Promise<void> {
        return http.post('/api/forum/topic/' + String(topicId) +'/vote/' + String(value));
    }

    public static voteComment(commentId: number, value: number): Promise<void> {
        return http.post('/api/forum/comment/' + String(commentId) +'/vote/' + String(value));
    }

}